import { Link } from "react-router-dom";
import { ArrowRight, Cable, Cctv } from "lucide-react";
import Reveal from "@/components/Reveal";
import { useLang } from "@/i18n";

export default function KitCta() {
  const { t } = useLang();
  const cards = [
    { to: "/kit-builder", Icon: Cable, label: t("kitcta_cabling"), testId: "kitcta-cabling" },
    { to: "/cctv-kit-builder", Icon: Cctv, label: t("kitcta_cctv"), testId: "kitcta-cctv" },
  ];
  return (
    <section data-testid="kit-cta-section" className="bg-[#ED1C24] px-6 md:px-12 lg:px-24 py-16 lg:py-20">
      <div className="grid lg:grid-cols-12 gap-10 items-center">
        <Reveal className="lg:col-span-6">
          <p className="text-xs tracking-[0.25em] uppercase text-white/70 mb-3">{t("kitcta_label")}</p>
          <h2 className="font-display font-semibold text-white text-3xl sm:text-5xl tracking-tight mb-3">
            {t("kitcta_title")}
          </h2>
          <p className="text-white/80 max-w-md">{t("kitcta_sub")}</p>
        </Reveal>
        <div className="lg:col-span-6 grid sm:grid-cols-2 gap-4">
          {cards.map(({ to, Icon, label, testId }, i) => (
            <Reveal key={to} delay={0.1 + i * 0.08}>
              <Link
                to={to}
                data-testid={testId}
                className="group flex items-center gap-4 bg-[#0B1120] hover:bg-black p-6 transition-colors duration-300"
              >
                <Icon size={26} className="text-[#FFC61A] shrink-0 group-hover:scale-110 transition-transform duration-300" />
                <span className="font-display font-semibold text-white text-lg flex-1">{label}</span>
                <ArrowRight size={20} className="text-white/60 group-hover:text-[#FFC61A] group-hover:translate-x-1 transition-all duration-300" />
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
